import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerBarWidthListItem = (props) => {
    const { visualizerBarWidth, updateVisualizerSettings, maxBarWidth } = props;
    
    const onWidthChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ barWidth: value });
    };
    
    return (
        <SliderListItem
            title='Bar Width'
            value={visualizerBarWidth}
            displayMultiplier={100 / maxBarWidth}
            min={0}
            max={100}
            step={1}
            onValueChange={onWidthChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { barWidth: visualizerBarWidth } = state.createPreview.present.videoSettings.visualizer;
    const { maxBarWidth } = state.create.maxValues;

    return { 
        visualizerBarWidth,
        maxBarWidth
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerBarWidthListItem);